import React from 'react';
/*
To import child routes, insert the following code:
import { <childComponent>Routes } from './components/<child-folder>';
*/

import { Route } from '@plasma/ui.application.router';

const GuideOrder = React.lazy(() => import('.'));

export const guideOrderRoutes = [
  new Route({
    path: 'guide-order',
    element: GuideOrder,
    children: [],
  }),
];
